<script setup lang="ts">
  import { MyAccountRoute } from "@/constants/routes/myAccount"
  import { Button } from "@/components/ui/button"
  import {
    Card,
    CardContent,
    CardFooter,
    CardTitle,
  } from "@/components/ui/card"
  import { Link } from "@/components/ui/link"

  import evChargingIllustration from "@/assets/illustrations/evCharging.svg"
</script>

<template>
  <Card data-testid="smart-charging-card">
    <CardContent>
      <div class="flex">
        <div class="min-w-[140px]">
          <CardTitle class="mb-6">EV Charging</CardTitle>
          <span>Manage your EV charging</span>
        </div>
        <img
          :src="evChargingIllustration"
          alt=""
          class="ml-auto w-auto max-w-[40%] flex-shrink"
        />
      </div>
    </CardContent>
    <CardFooter>
      <Button variant="tonal" as-child>
        <Link :to="MyAccountRoute.smartChargingApp">Go to EV Charging</Link>
      </Button>
    </CardFooter>
  </Card>
</template>
